exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-title-26nWUXbF {\n  color: #838991;\n  font-size: 14px;\n  font-weight: bold;\n  padding-top: 16px;\n  padding-left: 12px;\n}\n\n.styles-mostPopularWrapper-35iekpNj {\n  background-color: #121317;\n  padding-bottom: 26px;\n}\n\n@media (min-width: 1000px) {\n\n.styles-mostPopularWrapper-35iekpNj {\n    display: none\n}\n  }\n\n@media (max-width: 700px) {\n\n.styles-mostPopularWrapper-35iekpNj {\n    min-height: 175px\n}\n  }\n", ""]);

// exports
exports.locals = {
	"title": "styles-title-26nWUXbF",
	"mostPopularWrapper": "styles-mostPopularWrapper-35iekpNj"
};